import { LOCAL_STORAGE_ID_KEY } from '../constants.js';
import {} from '../models/environment.js';
import { version } from '../version.js';
import snakeCaseKeys from 'snakecase-keys';
const PICO_DOMAIN = {
    production: 'https://api.pico.bendingspoonsapps.com',
    staging: 'https://api.staging.pico.bendingspoonsapps.com',
};
const API_VERSION = 'v4';
export const picoApiManager = (config) => {
    const parseEvent = (event) => {
        let actionKind = undefined;
        let actionInfo = undefined;
        let subtype = undefined;
        let signInData = undefined;
        let userIds = event.userIds;
        if (event.type === 'UserAction') {
            actionKind = event.kind;
            actionInfo = event?.info ?? {};
        }
        if (event.type === 'SignIn') {
            userIds = {
                ...event.userIds,
                signInIds: event.signInIDs,
            };
            signInData = {
                provider: event.provider,
                isSignUp: event.isSignUp,
            };
        }
        if ('subtype' in event) {
            subtype = event.subtype;
        }
        return snakeCaseKeys({
            id: event.id,
            timestamp: event.timestamp,
            type: event.type,
            requestTimestamp: config.timestampGenerator(),
            app: config.bspId,
            user: {
                ids: userIds,
                info: event.userInfo,
            },
            data: {
                ...signInData,
                actionKind,
                actionInfo,
                subtype,
                sessionStartId: event.sessionStartId,
                sessionId: event.sessionId,
                secondsFromSessionStart: event.secondsFromSessionStart,
            },
        });
    };
    return {
        sendEvents: async (events) => {
            if (events[0] === undefined) {
                return;
            }
            const parsedEvents = events.map(parseEvent);
            const url = (() => {
                const environment = config.environment;
                switch (environment.type) {
                    case 'production':
                    case 'staging':
                        return `${PICO_DOMAIN[environment.type]}/${API_VERSION}/web-events`;
                    case 'custom':
                        return environment.url;
                }
            })();
            // The local storage id is constant for all users that use the same browser, we can retrieve it from any event to be forwarded.
            const localStorageId = events[0].userIds[LOCAL_STORAGE_ID_KEY];
            if (localStorageId === undefined) {
                throw new Error("Not all events have the `localStorageId` set, events won't be sent to the backend as they'll fail the validation.");
            }
            const response = await fetch(url, {
                method: 'POST',
                body: JSON.stringify({
                    events: parsedEvents,
                }),
                headers: {
                    'Pico-Client-ID': localStorageId,
                    'Pico-Version': version,
                    'Content-Type': 'application/json',
                    'bsp-id': config.bspId,
                },
            });
            if (response.status !== 200) {
                config.logger.error(`Received invalid response: ${response.status}`);
                throw new Error('Received invalid response!');
            }
        },
    };
};
//# sourceMappingURL=picoApiManager.js.map